import { Route, useRouteMatch, Switch } from 'react-router-dom';
import { ReportsProvider } from "./context"

import { Reports } from './indexReports';
// import { ReportsDetails } from './CreditsUsed/details';
import { ReportsDetails } from './CreditsReports/details';
import { RelatorioSuccess } from './CreditsReports/success';

export const IndexReports = () => {
  const { path } = useRouteMatch();
  return <ReportsProvider>
    <Switch>
      <Route exact path={`${path}/`} component={Reports} />
      <Route exact path={`${path}/:slug/detalhe`} component={ReportsDetails} />
      <Route exact path={`/home/relatorios/sucesso`} component={RelatorioSuccess} />
    </Switch>
  </ReportsProvider>
}